'use client'
import React, { useEffect } from 'react';

import { usePathname } from 'next/navigation';

export const SearchBar = ({scriptId}:{scriptId:string}) => {
    const pathname = usePathname()

    useEffect(() => {
        const script = document.createElement('script');
        const script2 = document.createElement('script');
        
        script.src = 'https://d3mvpbun2t0ap6.cloudfront.net/0e93b2b62c6a45ca97bdc9c7c2ed32b8/search-clients/'+scriptId+'/an.js';
        script.async = true;
        script2.src = 'https://d3mvpbun2t0ap6.cloudfront.net/0e93b2b62c6a45ca97bdc9c7c2ed32b8/search-clients/'+scriptId+'/searchbox.js';
        script2.async = true;

        document.body.appendChild(script);
        document.body.appendChild(script2);

        return () => {
            document.body.removeChild(script);
            document.body.removeChild(script2);
        };
    }, [pathname, scriptId]);

    return (
        <>
            <link rel="stylesheet" href={`https://d3mvpbun2t0ap6.cloudfront.net/0e93b2b62c6a45ca97bdc9c7c2ed32b8/search-clients/${scriptId}/searchbox.css`} />
            <div id="auto" className="su__homePageS_custom">
                <div ng-controller="SearchautoController">
                    <div bind-html-compile="autocompleteHtml"></div>
                </div>
            </div>
        </>
    );
}